import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, unref as _unref, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "mleft-04" }
const _hoisted_3 = { class: "col gap-10 mtop-06" }
const _hoisted_4 = { class: "w-full" }

import { ref, onMounted } from 'vue'
import appuserapi from "@/api/appuserapi"
import { useI18n } from "vue-i18n";

export default /*@__PURE__*/_defineComponent({
  __name: 'editRefDocument',
  props: {
  referenceDocument: {
    type: Object,
    required: true,
  },  
},
  emits: ["updateClose", "update"],
  setup(__props, { emit: __emit }) {

const { t } = useI18n();

const props = __props

const emits = __emit;

const focusRef = ref(null)
const titleContent = ref(props.referenceDocument.title)

async function deleteReferenceDocument() {
  const referenceDocumentId = props.referenceDocument.id
  const deletePromise = appuserapi.deleteReferenceDocument(referenceDocumentId)
  emits('updateClose', deletePromise)
}

async function updateTitle() {
  const referenceDocumentId = props.referenceDocument.id
  const newTitle = titleContent.value
  const oldTitle = props.referenceDocument.title
  if (newTitle === oldTitle) return
  const updatePromise = appuserapi.updateReferenceDocument(referenceDocumentId, { title: newTitle })
  emits('update', updatePromise)
}

onMounted(() => {
  focusRef.value.innerRef.focus()
})


return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_button_group = _resolveComponent("button-group")!
  const _component_inputAreaAuto2 = _resolveComponent("inputAreaAuto2")!
  const _component_inputBox = _resolveComponent("inputBox")!

  return (_openBlock(), _createElementBlock("div", {
    style: {"width":"22rem"},
    class: "bg-modal",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_text_item, {
        txt: __props.referenceDocument.title,
        styles: "font-l"
      }, null, 8, ["txt"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_button_group, {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (deleteReferenceDocument()))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_svg_item, {
              icon: "trash",
              styles: "main-m"
            })
          ]),
          _: 1
        })
      ])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_text_item, {
          txt: _unref(t)('common.title'),
          styles: "font-mBold main-l"
        }, null, 8, ["txt"]),
        _createVNode(_component_inputBox, { class: "pad-s mtop-02 w-full" }, {
          default: _withCtx(() => [
            _createVNode(_component_inputAreaAuto2, {
              ref_key: "focusRef",
              ref: focusRef,
              modelValue: titleContent.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((titleContent).value = $event)),
              onBlur: _cache[2] || (_cache[2] = ($event: any) => (updateTitle()))
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})